import React, { Component } from "react";
import _Phone from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { getSession } from "../../../../lib/auth";
import "./override.css";

function getValidationObj(props, value) {
  const valueMissing = props.required ? !value : false;
  let isValidPhone = true;
  if (value) {
    isValidPhone = isValidPhoneNumber(value);
  }

  return {
    valueMissing,
    phoneInvalid: !isValidPhone,
    valid: !valueMissing && isValidPhone,
  };
}

class Phone extends Component {
  constructor(props) {
    super(props);
    this.org = getSession().organization || {};
    this.handleChange = this.handleChange.bind(this);
    this.runValidation = this.runValidation.bind(this);
    this.state = {
      defaultCountryCode: this.org?.countryCode || "IN",
      validation: getValidationObj(props, props.value),
    };
  }

  handleChange(value) {
    this.props.onChange && this.props.onChange(value);
    this.runValidation(value);
  }

  runValidation(value) {
    const validation = getValidationObj(this.props, value);
    this.setState({ validation });
    this.props.onValidation &&
      this.props.onValidation({
        ...validation,
        errorMessage: validation.valueMissing
          ? "Phone number is required"
          : validation.phoneInvalid
            ? "Please enter valid phone number"
            : "",
      });
  }

  componentDidMount() {
    this.runValidation(this.props.value);
  }

  componentDidUpdate(prevProps, prevState) {
    const updatedLocalOrgData = getSession().organization || {};
    if (prevState.defaultCountryCode !== updatedLocalOrgData?.countryCode) {
      this.setState({
        defaultCountryCode: updatedLocalOrgData?.countryCode,
      });
    }

    if (prevProps.value !== this.props.value) {
      this.runValidation(this.props.value);
    }
  }

  render() {
    let {
      emphasize,
      onValidation,
      showErrors,
      onChange,
      country,
      required = false,
      label,
      placeholder,
      ...props
    } = this.props;
    const { validation } = this.state;
    let PhoneInput = _Phone;
    return (
      <div className="enterprise-phone-wrapper">
        <PhoneInput
          {...props}
          placeholder={
            placeholder
              ? placeholder + ((required && !label && " *") || "")
              : ""
          }
          onChange={this.handleChange}
          defaultCountry={country || this.state.defaultCountryCode}
          displayInitialValueAsLocalNumber
        />
        {showErrors && !validation.valid && (
          <div className="error-message">
            {validation.valueMissing
              ? "Phone number is required"
              : "Please enter valid phone number"}
          </div>
        )}
      </div>
    );
  }
}

export default Phone;
